// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';
export const plansTranslationsAr = {
  ...plansTranslationsEn,
  'plans.founder.remaining': 'متبقي {count} مقعد Founder',
  'plans.founder.remaining_last': 'آخر {count} مقاعد Founder',
  'plans.founder.remaining_limited': 'محدود: متبقي {count}',
  'plans.founder.remaining_very_low': 'لم يتبق سوى {count} مقعد Founder',
  'plans.founder.soldout': 'Founder نفد',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.compare.pro.adjustment_notice': 'قد يُعدَّل السعر وفقًا لشروط الخدمة.',
  'plans.compare.title': 'Choose your plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.cta.foundation': 'Become a Founder',
  'plans.compare.cta.pro': 'Upgrade to PRO',
  'plans.compare.active': 'Current plan',
  'plans.compare.limited': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.limit.reached': 'Limit reached — Upgrade plan',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'ترقية الخطة',
  'plans.modal.comparison_title': 'مقارنة الخطط',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'خطة مجانية',
  'plans.free.features.contacts': 'حد أقصى جهتي اتصال لكل مستخدم',
  'plans.free.features.conversations': 'حد أقصى محادثتين نشطتين لكل حساب',
  'plans.free.features.no_export': '30 ألف حرف شهريًا لكل حساب؛ 34 رسالة يوميًا و1000 شهريًا؛ بدون تصدير',
  'plans.free.features.no_advanced': 'بدون ملفات أو تخزين؛ سجل 30 يومًا؛ جهاز واحد لكل مستخدم',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'خطة Founder',
  'plans.foundation.features.contacts': 'نفس العقد المميز لـ PRO (حتى 100 جهات اتصال لكل مستخدم)',
  'plans.foundation.features.conversations': 'دردشات غير محدودة (مستأجر)؛ نفس حدود PRO',
  'plans.foundation.features.badge': 'برنامج Founder (150 مقعدًا مرقمًا)',
  'plans.foundation.features.support': 'USD 15 شهريًا طالما توجد مقاعد Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'خطة Pro',
  'plans.pro.features.contacts': 'حتى 100 جهة اتصال لكل مستخدم',
  'plans.pro.features.conversations': 'دردشات غير محدودة (مستأجر)؛ 1667 رسالة يوميًا و50 ألف شهريًا',
  'plans.pro.features.export': 'حتى 50 ميجابايت (مستأجر)؛ التصدير والترجمة والملفات حسب الخطة',
  'plans.pro.features.notifications': 'حتى 3 أجهزة لكل مستخدم؛ دعوات غير محدودة (مستأجر)',
  'plans.actions.free': 'الخطة الحالية',
  'plans.actions.foundation': 'كن Founder',
  'plans.actions.pro': 'الترقية إلى PRO',
  'plans.badges.recommended': 'موصى به',
  'plans.badges.limited': 'محدود',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': '30,000 حرفًا شهريًا لكل حساب.',
  'plans.modal.free.line2': 'حتى جهتي اتصال لكل مستخدم.',
  'plans.modal.free.line3': 'حتى محادثتين نشطتين لكل حساب.',
  'plans.modal.free.line4': 'بدون مرفقات أو مساحة تخزين.',
  'plans.modal.free.line5': 'بدون تصدير بيانات.',
  'plans.modal.free.line6': 'سجل الرسائل حتى 30 يومًا.',
  'plans.modal.free.line7': 'جهاز واحد فقط لكل مستخدم.',
  'plans.modal.premium.line1': '300,000 حرفًا شهريًا لكل حساب.',
  'plans.modal.premium.line2': 'حتى 100 جهة اتصال لكل مستخدم.',
  'plans.modal.premium.line3': 'محادثات ودردشات غير محدودة (tenant).',
  'plans.modal.premium.line4': 'حتى 50 ميغابايت تخزينًا (tenant).',
  'plans.modal.premium.line5': 'حتى 3 أجهزة لكل مستخدم.',
  'plans.modal.premium.line6': 'دعوات غير محدودة (tenant).',
  'plans.modal.premium.line7': 'يشمل التصدير والترجمة التلقائية والملفات ضمن حدود الخطة.',
  'plans.modal.premium_block_heading': 'حدود استخدام المحرك (مميز)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'برنامج Founder',
  'plans.modal.foundation.categories_title': 'فئات Founder ({slots} مقعدًا)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'المركز 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'أول من دعم المشروع. أعلى أولوية تاريخية.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'المركز 26–75',
  'plans.modal.foundation.cat_early_desc': 'دعم مبكر مع اعتراف خاص.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'المركز 76–150',
  'plans.modal.foundation.cat_std_desc': 'مقعد Founder ضمن الـ150.',
  'plans.modal.foundation.advantages_title': 'مزايا Founder',
  'plans.modal.foundation.adv1': 'الوصول إلى مجموعة Founder المحدودة ({slots} مقعدًا مرقّمًا).',
  'plans.modal.foundation.adv2': 'الاعتراف كمستخدم مؤسس لـ ArChat.',
  'plans.modal.foundation.adv3': 'شارة Founder وحضور في تجربة المنتج.',
  'plans.modal.foundation.adv4': 'أولوية تاريخية ومكانة حسب مركزك (1–150).',
  'plans.modal.foundation.adv5': 'فائدة مستمرة مرتبطة بوصول Founder طالما سارت السياسة الحالية.',
  'plans.modal.pro.tagline': 'بريميوم قياسي — بدون مكوّن Founder',
  'plans.payments_disabled.title': 'الاشتراكات',
  'plans.payments_disabled.message': 'يتم تفعيل الاشتراكات تدريجيًا. يمكنك الاطلاع على الخطط المتاحة ومزاياها.',
  'plans.payments_disabled.confirm': 'حسنًا',
};